module.exports = __webpack_public_path__ + "static/media/Setting.86255e49.svg";